import React, { Component } from 'react'
import PublicTimeTableComponent from "./PublicTimeTableComponent"
import { connect } from "react-redux"
import spinner from '../../ui/icons/spinner.gif'
import { TimeTableActions, I18nActions } from '../../../store';
import lodashUtil from 'lodash'
import theme from "../../../assests";

class PublicTimeTableContainer extends Component {
    componentDidMount() {
        this.props.getI18nMessages();
    }
    render() {
        if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
            return <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
        } else {
            return <PublicTimeTableComponent {...this.props} />
        }
    }
}

const mapStateToProps = (state) => {

    return {
        timeTableData: state.timeTable.timeTableData,
        getTimeTableInProgress: state.timeTable.getTimeTableInProgress,
        getTimeTableComplete: state.timeTable.getTimeTableComplete,
        getTimeTableFailed: state.timeTable.getTimeTableFailed,
        i18n: state.i18nMessages.i18n
    }
}
const mapDispatchToProps = (dispatch) => ({
    getTimeTableById: (timeTableId, typeId) => dispatch(TimeTableActions.getTimeTableById(timeTableId, typeId)),
    getI18nMessages: () => dispatch(I18nActions.getI18nMessages())
}
)

export default connect(mapStateToProps, mapDispatchToProps)(PublicTimeTableContainer)

